/**
 * Converts a Date object or date string to a noon-UTC ISO string.
 * Use this for ALL calendar-day dates before sending to the API.
 *
 * Why noon? Because midnight local time can shift to the previous day in UTC
 * for timezones behind UTC (like EST) or to the next day for timezones ahead.
 * Noon UTC is safe for all timezones from UTC-11 to UTC+11.
 *
 * @param {Date|string} date
 * @returns {string|null} ISO string at noon UTC, e.g. "2025-04-07T12:00:00.000Z"
 */
export function toNoonUTC(date) {
  if (!date) return null;
  const d = new Date(date);
  return new Date(
    Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 12, 0, 0, 0),
  ).toISOString();
}

/**
 * Formats a Date or ISO string as a local calendar date string "YYYY-MM-DD".
 * Use this when grouping by date (e.g. calendar grouping).
 */
export function toLocalDateKey(date) {
  if (!date) return null;
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/**
 * Formats a stored UTC date for display in the UI using the local timezone.
 */
export function formatDisplayDate(date, options = {}) {
  if (!date) return "—";
  return new Date(date).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    ...options,
  });
}
